import api from "./api";

export const pincodeService = {
  lookup: (pincode) => api.get(`/pincode/${pincode}`),
};
